import React from "react";
import parse from "html-react-parser";
import MoreBtn from "../ui/MoreBtn";

export default function SchedulePastSessionCard({
  id,
  title,
  lesson_start,
  lesson_status,
  program_link,
  program_title,
  recepient_name,
  recepient_image,
  session_room_link,
  view_session_link,
  more_actions,
}) {
  return (
    <div className="ibox schedule-lesson-card">
      <div className="ibox-content relative">
        <div className="row">
          <div className="col-xs-12">
            <div className="title text-in-one-string without-margin full-width">
              {title}
            </div>
          </div>
          <div className="col-md-8">
            <div className="coach-info mt10 text-in-one-string flex">
              <a target="_blank" href={decodeURI(session_room_link)}>
                <img
                  src={recepient_image}
                  className="pull-left main-image img-circle"
                  alt="avatar"
                />
              </a>
              <a
                target="_blank"
                href={decodeURI(session_room_link)}
                className="green"
              >
                {recepient_name}
              </a>
            </div>
            <div className="mt10 lesson-info text-in-one-string">
              Scheduled
              <strong>{lesson_start}</strong>
            </div>
            <div className="mt10 lesson-info text-in-one-string">
              Duration
              <strong>50 minutes</strong>
            </div>
            <div className="mt10 lesson-info text-in-one-string">
              Status
              <strong className="session-status">{parse(lesson_status)}</strong>
            </div>
            <div className="mt10 lesson-info text-in-one-string">
              Program
              <strong className="green">
                <a target="_blank" href={decodeURI(program_link)}>
                  {program_title}
                </a>
              </strong>
            </div>
          </div>
          <div className="col-md-4">
            <a
              href={view_session_link}
              className="btn btn-green  width-120 mt10"
              target="_blank"
            >
              View
            </a>
            <MoreBtn more_actions={more_actions} />
          </div>
        </div>
      </div>
    </div>
  );
}
